import { cn } from '@/lib/utils'

import { OrdemStatus } from '../entities/ordem'

type VisualStatus = 'done' | 'doing' | 'pending' | 'canceled'

const StatusMap: Record<
  OrdemStatus,
  Array<{
    visual: VisualStatus
    statusName: OrdemStatus
  }>
> = {
  ORCAMENTO: [{ statusName: 'ORCAMENTO', visual: 'doing' }],
  APROVACAO: [
    { statusName: 'ORCAMENTO', visual: 'done' },
    { statusName: 'APROVACAO', visual: 'doing' },
  ],
  EXECUCAO: [
    { statusName: 'ORCAMENTO', visual: 'done' },
    { statusName: 'APROVACAO', visual: 'done' },
    { statusName: 'EXECUCAO', visual: 'doing' },
  ],
  FINALIZADO: [
    { statusName: 'ORCAMENTO', visual: 'done' },
    { statusName: 'APROVACAO', visual: 'done' },
    { statusName: 'EXECUCAO', visual: 'done' },
    { statusName: 'FINALIZADO', visual: 'done' },
  ],
  CANCELADO: [{ statusName: 'CANCELADO', visual: 'canceled' }],
}

function getStepStatus(
  currentStatus: OrdemStatus,
  stepStatus: OrdemStatus,
): VisualStatus {
  const status = StatusMap[currentStatus].find(
    (status) => status.statusName === stepStatus,
  )

  return status?.visual || 'pending'
}

function Item({
  index,
  status,
  label,
}: {
  index: number
  status: VisualStatus
  label: string
}) {
  return (
    <li
      data-status={status}
      data-first={index === 1}
      data-last={index === 4}
      className={cn(
        'relative flex w-full items-center justify-center',
        "after:absolute after:top-4 after:inline-block after:h-0.5 after:w-full after:content-[''] lg:after:top-5",
        'after:left-1/2 data-[last=true]:after:-left-1/2',
        'after:bg-gray-200 data-[status=done]:after:bg-lime-600',
      )}
    >
      <div className="z-10 block whitespace-nowrap">
        <div>
          <span
            data-status={status}
            className={cn(
              'mx-auto mb-2 flex size-8 items-center justify-center rounded-full border-2 text-sm lg:size-10',
              'border-zinc-300 data-[status=doing]:border-lime-600 data-[status=done]:border-transparent',
              'bg-white data-[status=doing]:bg-lime-50 data-[status=done]:bg-lime-600',
              'text-zinc-800 data-[status=done]:text-white',
            )}
          >
            {index}
          </span>
          <span className="text-gray-800">{label}</span>
        </div>
      </div>
    </li>
  )
}

export function OrdemStepper({ status }: { status: OrdemStatus }) {
  if (status === 'CANCELADO')
    return (
      <div className="flex items-center justify-center text-sm font-medium text-red-500">
        <div>
          <span
            data-status={status}
            className={cn(
              'mx-auto mb-2 flex size-8 items-center justify-center rounded-full text-sm lg:size-10',
              'bg-red-600 text-white',
            )}
          >
            X
          </span>
          <span className="text-gray-800">Cancelado</span>
        </div>
      </div>
    )
  return (
    <div>
      <ol className="flex w-full items-center text-sm font-medium">
        <Item
          index={1}
          label="Orçamento"
          status={getStepStatus(status, 'ORCAMENTO')}
        />
        <Item
          index={2}
          label="Aprovação"
          status={getStepStatus(status, 'APROVACAO')}
        />
        <Item
          index={3}
          label="Execução"
          status={getStepStatus(status, 'EXECUCAO')}
        />
        <Item
          index={4}
          label="Finalizado"
          status={getStepStatus(status, 'FINALIZADO')}
        />
      </ol>
    </div>
  )
}
